import memberApi from 'modules/member/api'

export const login = async ({ commit, dispatch }, { data, cb }) => {
  const response = await memberApi.login(data)
  if (response.code === 200) {
    cb && cb()
    commit('LOGIN')
    dispatch('member/fetchAccountProfile')
  }
}

export const qrLogin = async ({ commit, dispatch }, { code, cb }) => {
  const response = await memberApi.qrLogin({ code })
  if (response.code === 200) {
    cb && cb()
    commit('LOGIN')
    dispatch('member/fetchAccountProfile')
  } else {
    cb && cb()
  }
}

export const logout = async ({ commit }, { cb }) => {
  const response = await memberApi.logout()
  if (response.code === 200) {
    commit('LOGOUT')
    cb && cb()
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js